import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, MessageCircle } from "lucide-react";
import { SITE, waUrl } from "../lib/site";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#000000] text-white relative"
    >
      <div className="g-stripe" />
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3 mb-6">
            <img
              src={SITE.logo}
              alt="O.G. Digital"
              className="h-14 w-auto object-contain"
            />
          </div>
          <p className="text-white/70 max-w-md leading-relaxed">
            Agência Google Partner especializada em Google Ads, Meta Ads e
            criação de sites de alta conversão. Há mais de 10 anos transformando
            cliques em clientes.
          </p>
          <a
            href={waUrl()}
            target="_blank"
            rel="noreferrer"
            data-testid="footer-whatsapp-cta"
            className="btn-whatsapp mt-8 inline-flex"
          >
            <MessageCircle size={18} />
            Falar no WhatsApp
          </a>
        </div>

        <div className="md:col-span-3">
          <p className="eyebrow text-white/50 mb-5">Navegação</p>
          <ul className="space-y-3">
            {[
              { to: "/", label: "Home" },
              { to: "/criacao-de-sites", label: "Criação de Sites" },
              { to: "/site-profissional", label: "Sites Rápidos" },
              { to: "/google-ads", label: "Google Ads" },
              { to: "/meta-ads", label: "Meta Ads" },
              { to: "/avaliacoes", label: "Avaliações" },
              { to: "/contato", label: "Contato" },
            ].map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-nav-${l.label.toLowerCase()}`}
                  className="text-white/70 hover:text-white transition-colors text-sm"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="eyebrow text-white/50 mb-5">Contato</p>
          <ul className="space-y-4 text-sm text-white/80">
            <li className="flex items-start gap-3">
              <Phone size={16} className="mt-1 text-[#34A853] shrink-0" />
              <a
                href={waUrl()}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-phone"
                className="hover:text-white"
              >
                WhatsApp: {SITE.whatsappDisplay}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin size={16} className="mt-1 text-[#EA4335] shrink-0" />
              <span>
                {SITE.address.line1}
                <br />
                {SITE.address.line2}
                <br />
                {SITE.address.cep}
              </span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-white/50">
          <p>
            © {new Date().getFullYear()} O.G. Marketing Digital. Todos os
            direitos reservados.
          </p>
          <div className="flex items-center gap-2">
            <span className="inline-block w-2 h-2 rounded-full bg-[#4285F4]" />
            <span className="inline-block w-2 h-2 rounded-full bg-[#EA4335]" />
            <span className="inline-block w-2 h-2 rounded-full bg-[#FBBC05]" />
            <span className="inline-block w-2 h-2 rounded-full bg-[#34A853]" />
            <span className="ml-2">Google Partner Certified</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
